export default {
  header: 'Ten tydzień',
  metrics: {
    points: 'Punkty',
    visits: 'Wizyty',
    in_store_sign_ups: 'Rejestracje w lokalu',
    rewards_redeemed: 'Wykorzystane nagrody',
  },
};
